import React, {useState, useEffect} from 'react'
import {useTranslation} from 'react-i18next'
import ErrorMsg from './NewMsgErr'
import {Stack} from '@mui/material'
import {useSelector} from 'react-redux'
import {RootState} from '../../store'
import MaxCharactersNote from './MaxCharactersNote'

interface Props {
  type: string
  value: any
  name: string
  change: any
  child?: string
  checked?: boolean
  placeholder?: any
  withoutBorder?: any
  changeName?: any
  isLink?: any
  otherName?: any
  errors?: any
  maxLength?: any
  isCurrency?: any
  isPercentage?: any
  characters?: any
  permalinkFun?: any
}

const InputType: React.FC<Props> = ({
  type,
  value,
  name,
  change,
  child,
  checked,
  placeholder,
  withoutBorder,
  changeName,
  isLink,
  otherName,
  errors,
  maxLength,
  isCurrency,
  isPercentage,
  characters,
  permalinkFun,
}) => {
  const [inputValue, setInputValue] = useState<any>('')

  const {t} = useTranslation()
  useEffect(() => {
    if (child && (!value || !value[name])) {
      change({...value, [name]: {}})
    }
  }, [child, name, change, value])

  useEffect(() => {
    if (child) {
      setInputValue(value && value[name] && value[name][child] ? value[name][child] : '')
    } else {
      setInputValue(value && value[name] ? value[name] : '')
    }
  }, [child, name, value])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value
    setInputValue(newValue)
    if (changeName && child) {
      change({
        ...value,
        [name]: {...value[name], [child]: newValue},
        [changeName]: {},
        isLink: isLink,
      })
    } else if (child) {
      if (permalinkFun) {
        const cleaned = newValue
          .normalize('NFD') // ➊ تحويل الأحرف المميزة (é -> e)
          .replace(/[\u0300-\u036f]/g, '') // إزالة العلامات المرافقة بعد normalize
          .toLowerCase() // ➋ تحويل إلى حروف صغيرة
          .slice(0, 60) // ➌ تقصير النص لـ 60 حرف كحد أقصى
          .replace(/[?&=,#%\/\\:"'<>{}\|\^\~`\[\]\(\)\$\@\!\*\+]/g, '') // ➍ حذف الرموز الخاصة
          .trim()
          .replace(/\s+/g, '-') // ➎ استبدال المسافات بـ "-"
          .replace(/-+/g, '-') // ➏ حذف التكرار في "-"

          .replace(/^-+|-+$/g, '') // ➐ حذف الـ "-" من البداية أو النهاية

        change({
          ...value,
          [name]: {
            ...value[name],
            [child]: cleaned,
          },
        })
      } else if (otherName) {
        const cleaned = newValue
          .normalize('NFD') // ➊ تحويل الأحرف المميزة (é -> e)
          .replace(/[\u0300-\u036f]/g, '') // إزالة العلامات المرافقة بعد normalize
          .toLowerCase() // ➋ تحويل إلى حروف صغيرة
          .slice(0, 60) // ➌ تقصير النص لـ 60 حرف كحد أقصى
          .replace(/[?&=,#%\/\\:"'<>{}\|\^\~`\[\]\(\)\$\@\!\*\+]/g, '') // ➍ حذف الرموز الخاصة
          .trim()
          .replace(/\s+/g, '-') // ➎ استبدال المسافات بـ "-"
          .replace(/-+/g, '-') // ➏ حذف التكرار في "-"

          .replace(/^-+|-+$/g, '')
        change({
          ...value,
          [name]: {...value[name], [child]: newValue},
          [otherName]: {
            ...value[otherName],
            [child]: cleaned,
          },
        })
      } else {
        change({...value, [name]: {...value[name], [child]: newValue}})
      }
    } else {
      console.log('herer', newValue)

      change({
        ...value,
        [name]: e.target.value == '0' ? newValue : type === 'number' ? +newValue : newValue,
      })
    }
  }
  const currency = localStorage.getItem('currency')
  const store = useSelector((state: RootState) => state.vender)

  return (
    <>
      <Stack position={'relative'}>
        <input
          maxLength={characters || maxLength || 'auto'}
          style={{
            padding: withoutBorder ? '12.0625px 4px 12.5px' : '12.0625px 13px 12.5px',
            background: checked ? '#c4d3e814' : 'var(--bs-body-bg)',
            border: withoutBorder ? 'none' : '1px solid var(--bs-gray-300)',
            borderRadius: '6.18px',
            width: '100%',
            color: 'var(--bs-text-dark)',
          }}
          className='login-input'
          placeholder={`${t(placeholder)}`}
          min={0}
          value={inputValue ? inputValue : !inputValue && type === 'number' ? '' : inputValue}
          onChange={handleChange}
          type={type}
          disabled={checked || false}
        />
        {(isPercentage || isCurrency) && (
          <Stack
            right={store.isRtl == 0 ? '0' : 'auto'}
            left={store.isRtl != 0 ? '0' : 'auto'}
            height={'100%'}
            p='15px'
            bgcolor={'#e3e3e3'}
            borderRadius={'8px'}
            position={'absolute'}
          >
            {isPercentage ? '%' : currency}
          </Stack>
        )}
      </Stack>
      <MaxCharactersNote characters={characters} />

      {errors && !child && errors[name] && typeof errors[name] === 'string' ? (
        <ErrorMsg msgErr={errors[name]} />
      ) : errors &&
        child &&
        errors[`${name}.${child}`] &&
        typeof errors[`${name}.${child}`] === 'string' ? (
        <ErrorMsg child={child} msgErr={errors[`${name}.${child}`]} />
      ) : (
        ''
      )}
    </>
  )
}

export default InputType
